package com.wintermar.inspection.core.ui.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_attachment
import inspection.composeapp.generated.resources.maximum_file
import inspection.composeapp.generated.resources.no_file_added
import inspection.composeapp.generated.resources.supported_image_label
import io.github.vinceglb.filekit.PlatformFile
import org.jetbrains.compose.resources.stringResource

@Composable
actual fun AttachContainer(
    enabled: Boolean,
    isError: Boolean,
    onPick: () -> Unit,
    onTakePhoto: (PlatformFile?) -> Unit,
    onFileDrop: (List<PlatformFile>?) -> Unit
) {
    AttachFileButton(
        enabled = enabled,
        isError = isError,
        modifier = Modifier
            .fillMaxWidth()
            //because space design system not have value > 200, so we adjust by multiplying
            .height(LocalAppTheme.current.dimension.spacing.space12 * 2f),
        onClick = onPick,
        onFileDrop = onFileDrop
    )
}

@Composable
actual fun InfoContainer(
    show: Boolean,
    label: String,
    supportLabel: String,
    emptyLabel: String,
    maxItems: Int,
    dimension: AppDimension,
    color: ThemeColor
) {
    Column(
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space1,
            alignment = Alignment.Top
        )
    ) {
        TextBodySmall(
            text = label,
            color = { it.subtle }
        )

        TextBodySmall(
            text = supportLabel,
            color = { it.subtle }
        )

        Spacer(modifier = Modifier.height(dimension.spacing.space2))
        AnimatedVisibility(visible = !show, enter = fadeIn(), exit = fadeOut()) {
            IconText(
                icon = Res.drawable.ic_attachment,
                text = emptyLabel,
                textColor = color.text.default,
                tint = color.icon.subtle,
                bold = true
            )
        }
        AnimatedVisibility(visible = show, enter = fadeIn(), exit = fadeOut()) {
            TextBodySmall(
                text = label,
                bold = true
            )
        }
    }
}
